import {
    CheckIcon as CheckIconSolid
} from '@heroicons/react/solid'

import {useState} from "react";

const tiers = [
    {
        name: 'Free Agent',
        href: '#',
        priceMonthly: 4.90,
        priceYearly: 24.90,
        description: 'All the basics for free agent and orgless teams',
        features: [
            'Scrims',
            'Statistical Reports'
        ]
    },
    {
        name: 'Rising Stars',
        href: '#',
        priceMonthly: 14.90,
        priceYearly: 59.90,
        description: 'All the solutions for small and mid sized teams',
        features: [
            'Scrims',
            'Advanced Reports',
            'Scouting',
            'Calendar',
            'Player Data',
            'Financial Management',
            'Job Boards'
        ]
    },
    {
        name: 'Champions',
        href: '#',
        priceMonthly: 29.90,
        priceYearly: 89.90,
        description: 'All the solutions for starting a new business',
        features: [
            'Scrims',
            'Advanced Reports',
            'Scouting',
            'Calendar',
            'Player Data',
            'Financial Management',
            'Job Boards',
            'Playbook',
            'Prioritized Data Support'
        ]
    },
    {
        name: 'Enterprise',
        href: '/support',
        priceMonthly: "?",
        priceYearly: "?",
        description: 'Historical and live data, statistics and content visualization',
        features: [
            'Reliable Data',
            'No Code Knowledge Needed',
            'Prediction Algorithms',
            'Live Stats',
            'Post-Game Player Ratings'
        ]
    },
];

const TYPE_MONTHLY = 0;
const TYPE_YEARLY = 1;

const Pricing = () => {
    const [type, setType] = useState(TYPE_MONTHLY)

    return (
        <div className="pb-12">
            <div className="max-w-7xl mx-auto pt-24 px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:flex-col sm:align-center">
                    <h1 className="text-5xl font-extrabold text-gray-900 sm:text-center">Pricing Plans</h1>

                    <p className="mt-5 text-xl text-gray-500 sm:text-center">
                        Start building for free, then add a site plan to go live. Account plans unlock additional features.
                    </p>

                    <div className="relative mt-6 bg-gray-100 rounded-lg p-0.5 flex self-center sm:mt-8">
                        <button
                            type="button"
                            className={`relative ${type === TYPE_MONTHLY ? "bg-white" : ""} border-gray-200 rounded-md shadow-sm py-2 w-1/2 text-sm font-medium text-gray-900 whitespace-nowrap sm:w-auto sm:px-8`}
                            onClick={() => setType(TYPE_MONTHLY)}
                        >
                            Monthly billing
                        </button>

                        <button
                            type="button"
                            className={`ml-0.5 relative ${type === TYPE_YEARLY ? "bg-white" : ""} border border-transparent rounded-md py-2 w-1/2 text-sm font-medium text-gray-700 whitespace-nowrap sm:w-auto sm:px-8`}
                            onClick={() => setType(TYPE_YEARLY)}
                        >
                            Yearly billing
                        </button>
                    </div>
                </div>

                <div className="mt-12 space-y-4 sm:mt-16 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-6 lg:max-w-4xl lg:mx-auto xl:max-w-none xl:mx-0 xl:grid-cols-4">
                    {tiers.map((tier) => (
                        <div key={tier.name} className="border border-gray-200 rounded-lg shadow-sm divide-y divide-gray-200">
                            <div className="p-6">
                                <h2 className="text-lg leading-6 font-medium text-gray-900">{tier.name}</h2>

                                <p className="mt-4 text-sm text-gray-500">{tier.description}</p>

                                <p className="mt-8">
                                    <span className="text-4xl font-extrabold text-gray-900">${type === TYPE_MONTHLY ? tier.priceMonthly : tier.priceYearly}</span>{' '}
                                    <span className="text-base font-medium text-gray-500">{type === TYPE_MONTHLY ? "/mo" : "/yr"}</span>
                                </p>

                                {tier.name === "Enterprise" && (
                                    <a
                                        href={tier.href}
                                        className="mt-8 block w-full bg-brand border border-transparent rounded-md py-2 text-sm font-semibold text-white text-center transition-colors hover:bg-indigo-600"
                                    >
                                        Contact Us
                                    </a>
                                )}

                                {tier.name !== "Enterprise" && (
                                    <a
                                        className="mt-8 block w-full bg-gray-100 border border-transparent text-gray-800 rounded-md py-2 text-sm font-semibold text-center transition-colors"
                                    >
                                        Subscribe Now
                                    </a>
                                )}
                            </div>
                            <div className="pt-6 pb-8 px-6">
                                <h3 className="text-xs font-medium text-gray-900 tracking-wide uppercase">What's included</h3>

                                <ul role="list" className="mt-6 space-y-4">
                                    {tier.features.map((feature) => (
                                        <li key={feature} className="flex space-x-3">
                                            <CheckIconSolid className="flex-shrink-0 h-5 w-5 text-green-500" aria-hidden="true" />

                                            <span className="text-sm text-gray-500">{feature}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Pricing;
